import { createEffect } from 'effector'
import { getDailyBonusInfo, getFarcanaBonusInfo, postClaimDailyBonus, postClaimFarcanaBonus } from './api'
import { ClaimDailyBonusDTO, GetDailyBonusInfoDTO, GetFarcanaBonusInfoDTO } from '@/entities/dailyBonus/model/types'

export const getDailyBonusInfoFx = createEffect(async (token: string): Promise<GetDailyBonusInfoDTO> => {
  const info = getDailyBonusInfo(token)
  return info
})

export const claimDailyBonusFx = createEffect(async (params: ClaimDailyBonusDTO) => {
  const response = postClaimDailyBonus(params.token, params.day, params.isPremium)
  return response
})

export const claimFarcanaBonusFx = createEffect(async (params: Omit<ClaimDailyBonusDTO, 'isPremium'>) => {
  const response = postClaimFarcanaBonus(params.token, params.day)
  return response
})

export const getFarcanaBonusInfoFx = createEffect(async (token: string): Promise<GetFarcanaBonusInfoDTO> => {
  const info = getFarcanaBonusInfo(token)
  return info
})
